import { Button, Input } from "antd";
import * as Icon from "@ant-design/icons";

function InputSearchBarcode({ filters, setFilters, placeholder = "Search All Items" }) {
    return (
        <Input
            value={filters.info}
            onChange={(e) => setFilters({ ...filters, info: e.target.value })}
            addonBefore={<Icon.SearchOutlined />}
            placeholder={placeholder}
            addonAfter={
                <Button type="link" size="small">
                    <Icon.BarcodeOutlined />
                </Button>
            }
        />
    );
}

export default InputSearchBarcode;
